import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-shield-plus",
  "use": "icon-si-glyph-shield-plus-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-shield-plus\" id=\"icon-si-glyph-shield-plus\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>752</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M2,1.961 L2,8.035 C2,13.051 8.546,15.948 8.546,15.948 C8.546,15.948 14.969,13.218 14.969,8.019 C14.969,2.823 14.971,1.96 14.971,1.96 C14.971,1.96 12.094,0.011 8.546,0.011 C4.998,0.011 2,1.961 2,1.961 Z M11.031,8.062 L9,8.062 L9,10 L7.938,10 L7.938,8.062 L6,8.062 L6,7 L7.938,7 L7.938,4.938 L9,4.938 L9,7 L11.031,7 L11.031,8.062 L11.031,8.062 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-shield-plus.svg
// module id = g6SY
// module chunks = 62